import moment from 'moment-timezone';
export const getUTCOffset = (date, timezone) => {
    const utcOffsetInMinutes = moment.tz(date, timezone).utcOffset();
    return utcOffsetInMinutes / 60;
};
